import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely read + parse a JSON value from localStorage. Returns `fallback`
 * if the key is missing, storage is unavailable (SSR/private mode), or the
 * stored value is malformed JSON. Never throws.
 */
export function safeReadJSON(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return fallback;
    return JSON.parse(raw);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[safeReadJSON] Failed to parse localStorage key "${key}":`, err);
    return fallback;
  }
}

/**
 * Safely read a raw string value from localStorage. Returns `fallback`
 * if storage is unavailable.
 */
export function safeReadString(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : raw;
  } catch (_) {
    return fallback;
  }
}
